export default __webpack_public_path__ + "static/7-4ac5c5b2129aa67da26a0ac5cbe19d6c.jpg";